<template>
    <div class="brand-detail">
        <bookNav :showSearch="true" searchStyle="brand" 
            @bkSearchShow="bkSearchShow" @bkSearchHide="bkSearchHide"
        ></bookNav>
        <div :class="bkSearchTabShow ? 'brand-d-fl cur' : 'brand-d-fl'">
            <div class="left-info">
                <div class="info-box">
                    <div class="tit">
                        <span @click="onBrandDetail">{{brandDetailList.name}}</span>
                        <a href="javascript:;" @click="onBrandDetail">查看详情 <a-icon type="right" /></a>
                    </div>
                    <div class="texts">{{brandDetailList.description}}</div>
                    <div class="descriptions">
                        <div class="dpt" v-if="brandDetailList.creator">
                            <span>品牌创始人</span>
                            <span>{{brandDetailList.creator}}</span>
                        </div>
                        <div class="dpt" v-if="brandDetailList.created">
                            <span>品牌创建时间</span>
                            <span>{{brandDetailList.created+'年'}}</span>
                        </div>
                        <div class="dpt" v-if="brandDetailList.place && brandDetailList.place.chsPlc">
                            <span>品牌创建地点</span>
                            <span>{{brandDetailList.place.chsPlc}}</span>
                        </div>
                        <div class="dpt" v-if="brandDetailList.organization && brandDetailList.organization.chsName">
                            <span>品牌所属公司</span>
                            <span>{{brandDetailList.organization.chsName['@value']}}</span>
                        </div>
                        <div class="dpt" v-if="brandDetailList.subBrand">
                            <span>同公司品牌</span>
                            <span v-if="brandDetailList.subBrand.length > 0">
                                {{arrayToString(brandDetailList.subBrand, 'name', '、')}}
                            </span>
                            <span v-else>{{brandDetailList.subBrand.name}}</span>
                        </div>
                    </div>
                </div>
                <div class="info-box">
                    <div class="tit">
                        文献来源 <a-icon type="down" />
                    </div>
                    <div class="hts" v-if="facetList && facetList.sourceFacet">
                        <div class="tg" v-for="(item, index) in facetList.sourceFacet" :key="'sourceFacet'+index">
                            <a href="javascript:;" 
                                :class="{'cur' : facetType=='SR'+index}"
                                @click="onFacet(item, 'SR', index)"
                            >{{item.facet}}</a>
                            <em>{{item.count}}</em>
                        </div>
                    </div>
                    <div class="tit">
                        广告发布者 <a-icon type="down" />
                    </div>
                    <div class="hts" v-if="facetList && facetList.publisherFacet">
                        <div class="tg" v-for="(item, index) in facetList.publisherFacet" :key="'publisherFacet'+index">
                            <a href="javascript:;" 
                                :class="{'cur' : facetType=='PBLS'+index}"
                                @click="onFacet(item, 'PBLS', index)"
                            >{{item.facet}}</a>
                            <em>{{item.count}}</em>
                        </div>
                    </div>
                    <div class="tit">
                        发布时间 <a-icon type="down" />
                    </div>
                    <div class="hts" v-if="facetList && facetList.sjFacet">
                        <div class="tg" v-for="(item, index) in facetList.sjFacet" :key="'sjFacet'+index">
                            <a href="javascript:;" 
                                :class="{'cur' : facetType=='SJ'+index}"
                                @click="onFacet(item, 'SJ', index)"
                            >{{item.facet}}</a>
                            <em>{{item.count}}</em>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-content">
                <div class="search-sort">
                    <div class="sort">
                        <span>找到<b>{{adRowCount}}</b>个结果</span>
                        <a-select default-value='1' v-model="sortRules" style="margin-right: 10px;" @change="onSortChange">
                            <a-select-option value="0">
                                降序
                            </a-select-option>
                            <a-select-option value="1">
                                升序
                            </a-select-option>
                        </a-select>
                        <a-select default-value='TI' v-model="sortContent" @change="onSortChange">
                            <a-select-option value="TI" title="题名">
                                题名
                            </a-select-option>
                            <a-select-option value="SJ" title="发布时间">
                                发布时间
                            </a-select-option>
                            <a-select-option value="score" title="相关度">
                                相关度
                            </a-select-option>
                        </a-select>
                    </div>
                    <div class="btn">
                        <!-- <a-checkbox v-model="allSelect" @change="()=>{}">
                            全选
                        </a-checkbox> -->
                        <!-- <a href="" class="pic"><img src="./pic/picicon.png" alt="">图像展示</a>
                        <a href=""><img src="./pic/ex.png" alt="">结果导出</a> -->
                        <a href="javascript:;" @click="charts"><img src="./pic/eye.png" alt="">结果可视化</a>
                    </div>
                </div>
                <div class="flow-box">
                    <div class="flow-lt" @mouseleave="handleLeave($event)" v-if="resultList">
                        <div class="f-c" @mouseenter="handleHover($event, item)" 
                            v-for="(item, index) in resultList.slice(0, resultListIndex0)" :key="'resultList1'+index"
                            @click="advertisementimg(item, index)"
                        >
                            <img :src="item.imgUrl" alt="">
                            <!-- <a-checkbox @change="()=>{}">
                                {{item.title}}
                            </a-checkbox> -->
                            <span>
                                {{item.title}}
                            </span>
                        </div>
                    </div>
                    <div class="flow-lt" @mouseleave="handleLeave($event)" v-if="resultList">
                        <div class="f-c" @mouseenter="handleHover($event, item)" 
                            v-for="(item, index) in resultList.slice(resultListIndex0, resultListIndex1)" :key="'resultList2'+index"
                            @click="advertisementimg(item, index)"
                        >
                            <img :src="item.imgUrl" alt="">
                            <span @change="()=>{}">
                                {{item.title}}
                            </span>
                        </div>
                    </div>
                    <div class="flow-lt" @mouseleave="handleLeave($event)" v-if="resultList">
                        <div class="f-c" @mouseenter="handleHover($event, item)" 
                            v-for="(item, index) in resultList.slice(resultListIndex1, resultListIndex2)" :key="'resultList3'+index"
                            @click="advertisementimg(item, index)"
                        >
                            <img :src="item.imgUrl" alt="">
                            <span @change="()=>{}">
                                {{item.title}}
                            </span>
                        </div>
                    </div>
                    <div class="flow-lt" @mouseleave="handleLeave($event)" v-if="resultList">
                        <div class="f-c" @mouseenter="handleHover($event, item)" 
                            v-for="(item, index) in resultList.slice(resultListIndex2)" :key="'resultList4'+index"
                            @click="advertisementimg(item, index)"
                        >
                            <img :src="item.imgUrl" alt="">
                            <span @change="()=>{}">
                                {{item.title}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="pages">
                    <!-- :showTotal="(total, range)=> `共 ${total} 条`" -->
                    <a-pagination 
                        v-model="adPageth"
                        showQuickJumper
                        :default-current="1"
                        :total="adRowCount"
                        :defaultPageSize="adPageSize"
                        @change="onPageChange"
                    />
                </div>
            </div>
        </div>

        <div class="brand-hover" v-if="showHoverBrand" 
            :style="{'top':hoverBrandY+'px','left':hoverBrandX+'px'}" 
            @mouseleave="handleLeave($event)" @mouseenter="brandHover($event)">
            <div class="despt">
                <div class="dt" v-if="hoverData.title">
                    <span>题名:</span>
                    <span>{{hoverData.title}}</span>
                </div>
                <div class="dt" v-if="hoverData.publisher">
                    <span>广告发布者:</span>
                    <span>{{arrayToString(hoverData.publisher, 'publisher', ' ')}}</span>
                </div>
                <div class="dt" v-if="hoverData.product">
                    <span>广告产品:</span>
                    <span>{{arrayToString(hoverData.product, 'name', '、')}}</span>
                </div>
                <div class="dt" v-if="hoverData.source">
                    <span>文献来源:</span>
                    <span>{{hoverData.source}}</span>
                </div>
                <div class="dt" v-if="hoverData.sj && hoverData.sj.year">
                    <span>出版时间:</span>
                    <span>{{hoverData.sj.year}}</span>
                </div>
                <div class="dt" v-if="hoverData.layout && hoverData.layout.serialNo">
                    <span>版次:</span>
                    <span>{{hoverData.layout.serialNo}}</span>
                </div>
                <div class="dt" v-if="hoverData.category">
                    <span>类别:</span>
                    <span>{{hoverData.category}}</span>
                </div>
                <div class="dt" v-if="hoverData.brandUri">
                    <span>相关品牌:</span>
                    <span>{{arrayToString(hoverData.brandUri, 'label', '、')}}</span>
                </div>
            </div>
            <!-- <div class="btns">
                <router-link to="/"><img src="./pic/yulanc.png" alt="">整本浏览</router-link>
                <router-link to="/"><img src="./pic/yulan2c.png" alt="">预览</router-link>
                <router-link to="/"><img src="./pic/zhuanjic.png" alt="">专辑浏览</router-link>
                <router-link to="/"><img src="./pic/xiazaic.png" alt="">下载</router-link>
            </div> -->
            <!-- <a-icon type="close" style="position: absolute;top: 8px;right: 8px" @click="handleLeave"></a-icon> -->
        </div>
    </div>
</template>

<script>
    import bookNav from './../nav2'
    export default {
        components:{
            bookNav
        },
        computed:{
            dateCount(){
                if(this.choseYear===''||this.choseMonth===''){
                    return 30
                }else{
                    return new Date(this.choseYear,this.choseMonth,0).getDate()
                }
            },
            brandDetailParams(){
                return {
                    uri: this.brandDetailUri,
                }
            },
            params(){
                return {
                    "searchType": this.adSearchType,
                    "expression": " ",
                    "freetext": "",
                    "cdtn": this.adCdtn,
                    "facet": this.adFacet,
                    "secondCdtn": "",
                    "pager": {
                        "pageth": this.adPageth,
                        "pageSize": this.adPageSize
                    },
                    "sorts": this.adSorts,
                    "hasFacet": true
                }
            },
            // activeResultList: function(){
            //     // if(typeof this.resultList.person == 'string') return this.resultList.person;
            //     return this.resultList.filter(function(item) {
            //         return item.imgUrl
            //     })
            // },
        },
        data(){
            return{
                allSelect:false,
                showHoverBrand:false,
                hoverBrandY:0,
                hoverBrandX:0,
                bkSearchTabShow: false,
                sortRules: '1',     // 排序规则
                sortContent: 'TI',  // 排序内容
                brandDetailUri: '', // 品牌uri
                adSearchType: 2,    // 检索类型， 1：简单检索，2：高级检索，3：专业检索
                adCdtn: [],         // 广告查询高级检索
                adFacet: {},        // 广告查询分面检索
                adSorts: {},        // 广告排序
                adPageth: 1,        // 第几页
                adPageSize: 20,     // 每页数量
                adPageCount: 1,     // 总页码
                resultList: [],     // 广告图片
                hoverData: {},      // 广告悬浮内容
                facetList: {},      // 广告分面
                adRowCount: 0,      // 广告总数
                isFacet: false,     // 是否分面点击
                isPage: false,      // 是否分页点击
                facetType: '',      // 分面点击样式
                brandDetailList: {},// 品牌详情数据
                resultListIndex0: 5,
                resultListIndex1: 10,
                resultListIndex2: 15,
            }
        },
        mounted(){
            this.$nextTick(()=>{
                this.setAdCdtn();
                this.getBrandDetail();
                // this.adSearch();
                this.onSortChange();
            })
        },
        methods:{
            getBrandDetail(){
                this.brandDetailParams.uri = localStorage.brandDetailUri;
                this.brandDetailAxios(); // 品牌
            },
            brandDetailAxios(){ // 海派品牌详情获取
                this.$axios.get(this.bkCommon.brandDetailUrl, {params: this.brandDetailParams})
                .then((res) => {
                    let resultData = res.data;
                    this.brandDetailList = resultData.data;
                })
                .catch((err) => {
                    console.log(err)
                });
            },
            adSearch(){ // 品牌广告
                this.$axios.post( this.bkCommon.adSearchUrl, this.params)
                .then((res) => {
                    let resultData   = res.data;
                    this.resultList  = resultData.datas;
                    this.onResultListIndex(); // 解决广告图片列表排版问题
                    if(!this.isPage){
                        if(!this.isFacet) this.facetList = resultData.facets;
                        this.adRowCount  = resultData.pager.rowCount;
                        this.adPageCount = resultData.pager.pageCount;
                    }
                    this.isFacet = false; // 是否分面点击
                    this.isPage  = false; // 是否分页点击
                })
                .catch((err) => {
                    console.error(err)
                });
            },
            setAdCdtn(){ // 高级检索设置
                let _brandUri = localStorage.brandDetailUri;
                this.adCdtn = [{
                    "logic": "and",
                    "field": "brandUri",
                    "value": _brandUri,
                    "type": "1"
                }]
            },
            onResultListIndex(){ // 解决广告图片列表排版问题
                if( this.isEmptyArray(this.resultList) ) return;
                let _round = Math.round(this.resultList.length/4);
                this.resultListIndex0 = _round;
                this.resultListIndex1 = _round*2;
                this.resultListIndex2 = _round*3;
            },
            onFacet(data, type, index){ // 分面点击
                this.isFacet    = true;
                this.adPageth   = 1;
                this.resultList = [];
                this.adFacet    = {};
                if(this.facetType !== type+index) {
                    this.facetType  = type+index;
                    this.adFacet[type] = data.facet;
                } 
                else this.facetType  = '';
                this.adSearch();
            },
            onPageChange(pageNumber){ // 分页点击
                this.adPageth = pageNumber;
                this.isPage   = true;
                this.resultList = [];
                this.adSearch();
            },
            onSortChange(){ // 排序
                this.adPageth = 1;
                this.adSorts  = {};
                this.adSorts[this.sortContent] = this.sortRules;
                this.adSearch();
            },
            onBrandDetail(){ // 跳转详情页
                localStorage.brandDetailUri = this.brandDetailList['@id'];
                this.$router.push("/bk/brandDetail");
            },
            advertisementimg(data, index){ // 跳转全文
                localStorage.advertisementData = this.$qs.stringify(data);
                this.$router.push('/bk/advertisementimg');
            },
            handleLeave(e){
                this.showHoverBrand=false
            },
            handleHover(e, data){
                this.hoverData = data;
                this.showHoverBrand=true
                this.hoverBrandX=e.clientX-390
                this.hoverBrandY=e.clientY+20
            },
            brandHover(){
                this.showHoverBrand=true
            },
            bkSearchShow(visible){
                this.bkSearchTabShow = visible;
                this.unScroll(); // 禁止滚动条滚动
            },
            bkSearchHide(visible){
                this.bkSearchTabShow = visible;
                this.removeUnScroll(); // 移除禁止滚动条滚动
            },
            charts(){
                localStorage.brabdVisParams = this.$qs.stringify(this.params);
                this.$router.push("/bk/brandHomeEcharts");
                // this.$router.push({name:"bkEcharts", params:{visParams: JSON.stringify(this.params)}});
            },
        }
    }
</script>

<style lang="less" scoped>
    .brand-detail{
        background: #e3e3e3;
        /deep/ .ant-checkbox + span{
            padding-left: 3px;
        }
        .brand-hover{
            position: fixed;
            width: 400px;
            background: #7ba0b3;
            padding: 12px;
            border-radius: 10px;
            top: 400px;
            left: 0;
            z-index: 999;
            .despt{
                color: #fff;
                // border-bottom: 1px solid #666;
                padding-bottom: 10px;
                .dt{
                    display: flex;
                    justify-content: space-between;
                    span{
                        font-size: 12px;
                        &:first-child{
                            font-weight: bold;
                            width: 80px;
                            flex-shrink: 0;
                        }
                        &:nth-child(2){
                            flex: 1;
                        }
                    }
                }
            }
            .btns{
                justify-content: space-between;
                display: flex;
                padding: 10px 20px 0 20px;
                border-top: 1px solid #efefef;
                a{
                    display: flex;
                    align-items: center;
                    color: #fff;
                    line-height: 34px;
                    font-size: 12px;
                    border-bottom: none;
                    img{
                        width: 20px;
                        height: 20px;
                        margin-right: 6px;
                    }
                }
            }
        }
        .brand-d-fl{
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 0 2%;
            &.cur{
                opacity: 0.1;
            }
            .right-content{
                background: #f7f7f7;
                border-radius: 10px;
                padding: 20px;
                flex: 1;
                margin-left: 10px;
                .pages{
                    margin-top: 20px;
                    display: flex;
                    justify-content: flex-end;
                }
                .flow-box{
                    display: flex;
                    justify-content: space-between;
                    margin-top: 15px;
                    .flow-lt{
                        width: 24%;
                        .f-c{
                            background: #fff;
                            box-shadow: 0 2px 4px #ccc;
                            width: 100%;
                            box-sizing: border-box;
                            padding: 5px;
                            margin-bottom: 10px;
                            cursor: pointer;
                            img{
                                width: 100%;
                                height: auto;
                                display: block;
                                margin-bottom: 10px;
                            }
                        }
                    }
                }
                .search-sort{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .sort{
                        span{
                            color: #888;
                            margin-right: 10px;
                            b{
                                color: #1473a5;
                            }
                        }
                    }
                    .btn{
                        display: flex;
                        align-items: center;
                        a{
                            height: 32px;
                            background: #1473a5;
                            color: #fff;
                            border-radius: 5px;
                            padding: 0 10px;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            margin-left: 10px;
                            &.pic{
                                background: #deaf68;
                            }
                            img{
                                max-width: 18px;
                                margin-right: 5px;
                            }
                        }
                    }
                }
            }
            .left-info{
                width: 40%;
                max-width: 400px;
                min-width: 300px;
                .info-box{
                    background: #fff;
                    border-radius: 10px;
                    padding: 20px;
                    margin-bottom: 20px;
                    .hts{
                        max-height: 254px;
                        margin-bottom: 15px;
                        overflow: auto;
                        .tg{
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            margin-bottom: 5px;
                            a{
                                flex: 1;
                                color: #666;
                                &:hover{
                                    color: #1473a5;
                                }
                                &.cur{
                                    color: rgb(20,115,165;0.6);
                                    font-weight: bold;
                                }
                            }
                            em{
                                width: 40px;
                                height: 18px;
                                background: #ebf1f4;
                                text-align: center;
                                line-height: 18px;
                                font-size: 12px;
                                border-radius: 9px;
                                color: #1473a5;
                            }
                        }
                        // 滚动条样式
                        &::-webkit-scrollbar {
                            width: 6px;
                            height: 6px;
                            z-index: 600;
                        }
                        &::-webkit-scrollbar-thumb {
                            border-radius: 10px;
                            -webkit-box-shadow: inset 0 0 5px rgba(227, 227, 227, 1);
                            box-shadow: inset 0 0 5px rgba(227, 227, 227, 1);
                            background: rgba(227, 227, 227, 1);
                        }
                        &::-webkit-scrollbar-track {
                            -webkit-box-shadow: inset 0 0 5px rgba(227, 227, 227, 0.4);
                            box-shadow: inset 0 0 5px rgba(227, 227, 227, 0.4);
                            border-radius: 5px;
                            background: rgba(227, 227, 227, 0.2);
                        }
                    }
                    .descriptions{
                        margin-top: 10px;
                        .dpt{
                            border-bottom: 1px solid #ccc;
                            display: flex;
                            justify-content: space-between;
                            line-height: 1.6;
                            span{
                                padding: 5px 0;
                                &:nth-child(1){
                                    width: 35%;
                                    font-weight: bold;
                                    flex-shrink: 0;
                                }
                                &:nth-child(2){
                                    flex: 1;
                                }
                            }
                        }
                    }
                    .texts{
                        font-size: 14px;
                        line-height: 1.6;
                        color: #666464;
                    }
                    .tit{
                        font-size: 16px;
                        color: #1473a5;
                        font-weight: bold;
                        position: relative;
                        margin-bottom: 10px;
                        a{
                            position: absolute;
                            right: 0;
                            top: 5px;
                            line-height: 1;
                            font-size: 12px;
                        }
                    }
                }
            }
        }
    }
</style>
